(function() {
  if (window.__egBisModalBound) return;

  window.__egBisModalBound = true;

  document.addEventListener('DOMContentLoaded', function() {
    const pendingOpenKey = 'egBisPendingOpen';
    const reloadKeyPrefix = 'egBisReloaded:';

    function getCustomerEmail() {
      return window.Shopify && window.Shopify.customer && window.Shopify.customer.email
        ? window.Shopify.customer.email
        : '';
    }

    function getModalEmailInput(modal) {
      return modal ? modal.querySelector('input[type="email"], input[name*="email" i]') : null;
    }

    function getCurrentVariantId(sourceElement) {
      if (!document.querySelector) return '';

      const form = sourceElement && sourceElement.closest ? sourceElement.closest('form') : null;
      const productInfo = sourceElement && sourceElement.closest ? sourceElement.closest('[id^="ProductInfo-"]') : null;
      const root = form || productInfo || document;
      const variantInput = root.querySelector('input.product-variant-id[name="id"], input[name="id"]');
      return variantInput && variantInput.value ? variantInput.value : '';
    }

    function getUrlVariantId() {
      try {
        return new URL(window.location.href).searchParams.get('variant') || '';
      } catch (error) {
        return '';
      }
    }

    function setStorageItem(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (error) {}
    }

    function getStorageItem(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    function removeStorageItem(key) {
      try {
        window.sessionStorage.removeItem(key);
      } catch (error) {}
    }

    function removeNotifyParam() {
      try {
        const url = new URL(window.location.href);
        if (!url.searchParams.has('eg_notify')) return;
        url.searchParams.delete('eg_notify');
        window.history.replaceState({}, '', url.toString());
      } catch (error) {}
    }

    function shouldReloadForSelectedVariant(modal, notifyButton) {
      const embed = modal ? modal.querySelector('#omnisend-embedded-v2-6961342178dc034b93340bd6') : null;
      const variantId = getCurrentVariantId(notifyButton);
      const urlVariantId = getUrlVariantId();

      return Boolean(
        embed &&
        !getModalEmailInput(modal) &&
        variantId &&
        variantId !== urlVariantId &&
        !getStorageItem(reloadKeyPrefix + variantId)
      );
    }

    function reloadForSelectedVariant(notifyButton) {
      const variantId = getCurrentVariantId(notifyButton);
      if (!variantId) return false;

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        url.searchParams.set('eg_notify', '1');
        setStorageItem(pendingOpenKey, '1');
        setStorageItem(reloadKeyPrefix + variantId, '1');
        window.location.assign(url.toString());
        return true;
      } catch (error) {
        return false;
      }
    }

    function setEmailInputValue(input, email) {
      if (!input || !email || input.value) return;

      const InputElement = window.HTMLInputElement || (typeof HTMLInputElement !== 'undefined' ? HTMLInputElement : null);
      const valueSetter = InputElement
        ? Object.getOwnPropertyDescriptor(InputElement.prototype, 'value')
        : null;

      if (valueSetter && typeof valueSetter.set === 'function') {
        valueSetter.set.call(input, email);
      }

      input.value = email;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function prefillCustomerEmail(modal, attempt) {
      const email = getCustomerEmail();
      if (!modal || !email) return;

      const emailInput = getModalEmailInput(modal);
      if (emailInput) {
        setEmailInputValue(emailInput, email);
        return;
      }

      if (attempt < 10) {
        setTimeout(function() {
          prefillCustomerEmail(modal, attempt + 1);
        }, 250);
      }
    }

    document.addEventListener('click', function(event) {
      const notifyButton = event.target.closest('.bis-notify-button');
      if (notifyButton) {
        const modalId = notifyButton.getAttribute('data-modal-target');
        const modal = modalId ? document.getElementById(modalId) : null;
        if (modal) {
          if (shouldReloadForSelectedVariant(modal, notifyButton) && reloadForSelectedVariant(notifyButton)) return;

          modal.style.display = 'block';
          document.body.style.overflow = 'hidden';
          prefillCustomerEmail(modal, 0);
        }
        return;
      }

      const closeButton = event.target.closest('.bis-modal-close');
      const overlay = event.target.classList && event.target.classList.contains('bis-modal-overlay') ? event.target : null;
      const modal = closeButton ? closeButton.closest('.bis-modal') : overlay ? overlay.closest('.bis-modal') : null;
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });

    // Handle ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.bis-modal').forEach(modal => {
          modal.style.display = 'none';
          document.body.style.overflow = '';
        });
      }
    });

    function openPendingNotify(attempt) {
      let urlShouldOpen = false;
      try {
        urlShouldOpen = new URL(window.location.href).searchParams.get('eg_notify') === '1';
      } catch (error) {}

      const shouldOpen = getStorageItem(pendingOpenKey) === '1' || urlShouldOpen;
      if (!shouldOpen) return;

      const notifyButton = document.querySelector('.bis-notify-button');
      const modalId = notifyButton ? notifyButton.getAttribute('data-modal-target') : '';
      const modal = modalId ? document.getElementById(modalId) : null;

      if (notifyButton && modal && (getModalEmailInput(modal) || attempt >= 40)) {
        removeStorageItem(pendingOpenKey);
        removeNotifyParam();
        notifyButton.click();
        return;
      }

      if (attempt < 40) {
        setTimeout(function() {
          openPendingNotify(attempt + 1);
        }, 250);
      }
    }

    openPendingNotify(0);
  });
})();
